import { useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCallback } from 'react'

const useSetCognitoUserEnabled = () => {
  const [request] = useFetchRefactored()

  const setCognitoUserEnabled = useCallback(
    (personId: number, enabled: boolean) => {
      return request({
        method: 'post',
        url: `/people/${personId}/cognito-user`,
        config: {
          queryStringParameters: {
            action: enabled ? 'enable' : 'disable',
          },
        },
      })
    },
    [request],
  )

  return setCognitoUserEnabled
}

export default useSetCognitoUserEnabled
